if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true' || !this.form.querySelector('[name=id]').value) return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) this.cart.setActiveElement(document.activeElement);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.renderCart(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.renderCart(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    async renderCart(response) {
      try {
        /*
         * Always request the cart drawer afresh after a successful add. App-added
         * line-item properties can change Shopify's bundled section response, so
         * relying on that response made the drawer intermittently fail to render.
         */
        const drawerResponse = await fetch(`${window.routes.cart_url}?section_id=cart-drawer&build=wuollet-v9-20260804`, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          cache: 'no-store'
        });
        if (!drawerResponse.ok) throw new Error(`Unable to refresh cart drawer (${drawerResponse.status})`);

        const drawerHTML = await drawerResponse.text();
        const parsed = new DOMParser().parseFromString(drawerHTML, 'text/html');
        const freshDrawer = parsed.querySelector('#CartDrawer');
        const currentDrawer = this.cart.querySelector('#CartDrawer');
        if (!freshDrawer || !currentDrawer) throw new Error('Cart drawer markup was not returned');

        currentDrawer.innerHTML = freshDrawer.innerHTML;
        this.cart.classList.remove('is-empty');
        this.cart.bindDrawerEvents();

        const cartResponse = await fetch(`${window.routes.cart_url}.js?build=wuollet-v9-20260804`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          this.cart.updateHeaderCount(cart.item_count);
        }

        this.cart.open(this.submitButton);
      } catch (error) {
        console.error('Wuollet cart drawer refresh failed:', error);
        window.location.assign(window.routes.cart_url);
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
